import {Badge} from 'antd';
import {LoadingOutlined} from '@ant-design/icons';
import React, {useCallback, useMemo} from 'react';
import {Link} from 'react-router-dom';

import {User} from '../../libs/types/src';
import {CONSTANTS, IconWrapper, moveScrollBySelector} from '../../libs/ui/src';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export const InboxNavigation = ({
  page,
  client,
  users,
  unreadCountByUser,
  inboxLoading,
  selectedInboxUser,
  openMenuItems,
  setSettings,
  isNavCollapsed,
}) => {
  const getUnreadCountForUser = useCallback(
    (user: User) => {
      const countItem = unreadCountByUser?.find((option: any) => String(option.user_id) === String(user.id));
      return countItem ? countItem.count : 0;
    },
    [unreadCountByUser]
  );
  const archivedUsers = useMemo(() => users.filter(user => user.archived), [users]);
  const unarchivedUsers = useMemo(() => users.filter(user => !user.archived), [users]);

  const totalUnreadCount = useMemo(() => {
    if (!isNavCollapsed) return 0;

    const unreadCountByActiveUser = unreadCountByUser.filter(({user_id}) => {
      const item = users.find((user: User) => String(user.id) === String(user_id));
      return item && !item.archived;
    });

    return unreadCountByActiveUser.reduce((acc: number, curr) => acc + curr.count, 0);
  }, [isNavCollapsed, unreadCountByUser, users]);

  const onTitleClick = (keys: any) => {
    if (!openMenuItems.includes(keys.key)) {
      setSettings({openMenuItems: [...openMenuItems, keys.key]});
      moveScrollBySelector('.navigation');
    } else {
      setSettings({openMenuItems: [CONSTANTS.inbox_page_key]});
    }
  };
  const subItems = unarchivedUsers.map((user: User) => {
    return ({
      key: `${user.id}`,
      disabled: client.team_member && client.team_member.user && user.id !== client.team_member.user,
      label: (
        <Link to={`/inbox/${user.id}`}>
          {user.first_name || user.email} <Badge count={getUnreadCountForUser(user)} />{' '}
          {inboxLoading && selectedInboxUser === String(user.id) && <LoadingOutlined />}
        </Link>
      )
    })
  });
  if (archivedUsers && archivedUsers.length > 0) {
    const archivedSubItems = archivedUsers.map((user: User) => ({
      className: 'navigation__inbox-submenu-item archived',
      key: `${user.id}`,
      disabled: client.team_member && client.team_member.user && user.id !== client.team_member.user,
      label: (
        <Link to={`/inbox/${user.id}`}>
          {user.first_name || user.email} <Badge count={getUnreadCountForUser(user)} />{' '}
          {inboxLoading && selectedInboxUser === String(user.id) && <LoadingOutlined />}
        </Link>
      )
    }));
    subItems.push(
      {
        key: page.key + '_archived',
        onTitleClick,
        label: (
          <>
            {page.icon}
            <span>Archived</span>
          </>
        ),
        className: 'navigation__inbox-submenu archived',
        children: archivedSubItems,
      }
    )
  }

  return {
    key: page.key,
    label: (
      <Link to={`/inbox/`}>
        <IconWrapper>
          <Badge count={totalUnreadCount} size="small" className="inbox-badge">
            <FontAwesomeIcon icon={{prefix: 'fas', iconName: 'inbox'}} />
          </Badge>
        </IconWrapper>
        <span>{page.label}</span>
      </Link>
    ),
    className: 'navigation__inbox-submenu',
    children: subItems,
  }
};
